<template>
  <div>
    <div class="c-base-transaction-details__price">
      <div class="c-base-transaction-details__icon">
        <base-icon width="24" height="24" :name="icon" />
      </div>
      <div class="c-base-transaction-details__amount">
        {{ transaction.amount | currency }}
      </div>

      <p class="c-base-transaction-details__category">
        <strong>Cashback</strong><br />
        Shopping Casar.com
        <br />
        <small>Realizada em {{ transaction.created_at | date }}</small>
      </p>
    </div>

    <div
      class="c-base-transaction-details__body c-base-transaction-details--body-orders"
    >
      <div
        v-for="(cashback, index) in cashbacks"
        :key="index"
        class="columns is-mobile is-gapless is-multiline is-vcentered margin-bottom"
      >
        <div class="column is-half">
          <p class="is-size-6">
            <strong>Cashback de {{ cashback.supplier_name }}</strong>
          </p>
        </div>
        <div class="column is-half has-text-right">
          <strong class="is-size-6 has-text-support">
            {{ cashback.cashback_amount | currency }}
          </strong>
        </div>
        <div class="margin-bottom">
          <a
            @click="
              userValidateToRedirect('details', '', cashback.external_order_id)
            "
            class="c-base-transaction-details has-text-underline"
            >Ver detalhes do pedido {{ cashback.external_order_id }}</a
          >
        </div>
      </div>

      <div class="c-base-transaction-details__footer">
        <a
          v-if="referenceTransaction"
          @click="emitReferenceTransaction"
          class="columns is-vcentered is-mobile is-gapless is-multiline margin-bottom"
          href="#"
        >
          <div class="column">
            <p class="has-text-black margin-bottom">
              Referente à compra realizada em<br />
              <strong> Shopping Casar.com </strong>
              <br />
            </p>
            <p class="has-text-black">
              Em {{ referenceTransaction.created_at | date }}
            </p>
          </div>
          <div class="column has-text-right is-1">
            <base-icon
              width="24px"
              height="24px"
              name="painel/arrow-right-icon"
              class="has-text-grey-dark"
            />
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTransactionDetailsMixin from '@/mixins/BaseTransactionDetailsMixin'
import verifyDataUserMixin from '@/mixins/verifyDataUserMixin'

import WalletApi from '@/lib/api/Wallet'

export default {
  mixins: [BaseTransactionDetailsMixin, verifyDataUserMixin],

  props: {
    transaction: {
      type: Object,
      required: true,
    },
    icon: String,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    transactions() {
      return this.$store.state.wallet.transactions
    },

    externalToken() {
      return this.$store.state.wallet.externalToken
    },

    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },

    transactionsLoadeds: {
      get() {
        return this.$store.state.wallet.transactionsLoadeds
      },
      set(payload) {
        this.$store.dispatch('setTransactionsLoadeds', payload)
      },
    },
  },

  data() {
    return {
      cashbacks: [],
      referenceTransaction: null,
    }
  },

  mounted() {
    this.getCashbacks()
    this.getReferenceTransaction()
  },

  methods: {
    getCashbacks() {
      const walletApi = new WalletApi(this.logonToken)
      walletApi
        .getCashbacks(this.transaction.reference_id)
        .then((response) => {
          this.cashbacks = response.data.data
          this.cashbacksLoadeds
        })
        .catch((error) => console.error(error))
    },

    getReferenceTransaction() {
      const reference = this.transactionsLoadeds.find(
        (transaction) =>
          transaction.transaction_id === this.transaction.reference_id
      )
      if (reference) {
        this.referenceTransaction = reference
        return
      }
      const walletApi = new WalletApi(this.logonToken)
      walletApi
        .getTransaction(this.transaction.reference_id)
        .then((response) => {
          this.referenceTransaction = response.data.data
          this.transactionsLoadeds = this.transactionsLoadeds.concat(
            this.referenceTransaction
          )
          this.referenceTransaction
        })
        .catch(null)
    },

    emitReferenceTransaction() {
      this.$emit('open-reference')
    },

    userValidateToRedirect(params, redirectTypeName, cashback_id) {
      if (this.verifyDataUser()) {
        this.goTo(params, redirectTypeName, cashback_id)
      } else {
        this.$refs.CPFModalPix.open()
      }
    },
  },
}
</script>
